import apiClient from "../../../utils/interceptor";
import {
  ApiResponse,
  VarietyData,
  CreateVarietyParams,
  UpdateVarietyParams,
  CreateVarietyResponse,
} from "./interface";
import { API_URLS } from "../../../constants";

// Helper to get auth token
const getAuthToken = (): string | null => {
  return localStorage.getItem("auth_token");
};

// Get all varieties for a specific crop
export const getVarietiesByCropId = async (
  cropId: string
): Promise<ApiResponse<VarietyData[]>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.get<ApiResponse<VarietyData[]>>(
      `${API_URLS.VARIETY.GET_VARIETIES}/${cropId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching varieties:", error);
    throw error;
  }
};

// Create a new variety
export const createVariety = async (
  params: CreateVarietyParams
): Promise<ApiResponse<CreateVarietyResponse>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.post<ApiResponse<CreateVarietyResponse>>(
      API_URLS.VARIETY.CREATE_VARIETY,
      params,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating variety:", error);
    throw error;
  }
};

// Update a variety
export const updateVariety = async (
  params: UpdateVarietyParams
): Promise<ApiResponse<null>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.patch<ApiResponse<null>>(
      API_URLS.VARIETY.UPDATE_VARIETY,
      params,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating variety:", error);
    throw error;
  }
};

// Delete (disable) a variety
export const deleteVariety = async (
  varietyId: string
): Promise<ApiResponse<null>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.delete<ApiResponse<null>>(
      API_URLS.VARIETY.DELETE_VARIETY,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: { variety_id: varietyId },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting variety:", error);
    throw error;
  }
};
